import { cva } from 'class-variance-authority'

export const tagVariants = cva('inline-flex items-center gap-1 rounded-full border border-transparent transition-colors duration-150 cursor-default hover:duration-75 whitespace-nowrap', {
    variants: {
        variant: {
            default: '',
            neutral: '',
            error: '',
            warning: '',
            missing: '',
            success: '',
        },
        size: {
            sm: 'py-0 px-2 paragraph-xs-medium h-5',
            md: 'px-3 py-1 paragraph-sm-medium',
        },
        outline: { true: 'border bg-primary' },
        disabled: { true: '' },
        clickable: { true: 'cursor-pointer', false: '' },
    },
    defaultVariants: {
        variant: 'default',
        size: 'md',
        outline: false,
        clickable: false,
    },
    compoundVariants: [
        // Solid variants (non-clickable)
        { variant: 'default', disabled: false, outline: false, clickable: false, class: 'bg-default text-default' },
        { variant: 'neutral', disabled: false, outline: false, clickable: false, class: 'bg-disabled text-secondary' },
        { variant: 'error', disabled: false, outline: false, clickable: false, class: 'bg-error text-error-secondary' },
        { variant: 'warning', disabled: false, outline: false, clickable: false, class: 'bg-warning text-warning-secondary' },
        { variant: 'missing', disabled: false, outline: false, clickable: false, class: 'bg-missing text-missing-secondary' },
        { variant: 'success', disabled: false, outline: false, clickable: false, class: 'bg-success text-success-secondary' },

        // Solid variants (clickable - with hover)
        { variant: 'default', disabled: false, outline: false, clickable: true, class: 'bg-default text-default hover:bg-default-hover' },
        { variant: 'neutral', disabled: false, outline: false, clickable: true, class: 'bg-disabled text-secondary hover:bg-secondary-hover' },
        { variant: 'error', disabled: false, outline: false, clickable: true, class: 'bg-error text-error-secondary hover:bg-error-hover' },
        { variant: 'warning', disabled: false, outline: false, clickable: true, class: 'bg-warning text-warning-secondary hover:bg-warning-hover' },
        { variant: 'missing', disabled: false, outline: false, clickable: true, class: 'bg-missing text-missing-secondary hover:bg-missing-hover' },
        { variant: 'success', disabled: false, outline: false, clickable: true, class: 'bg-success text-success-secondary hover:bg-success-hover' },

        // Outline variants (non-clickable)
        { variant: 'default', disabled: false, outline: true, clickable: false, class: 'border-focus text-cta' },
        { variant: 'neutral', disabled: false, outline: true, clickable: false, class: 'border-secondary text-secondary' },
        { variant: 'error', disabled: false, outline: true, clickable: false, class: 'border-error text-error-core' },
        { variant: 'warning', disabled: false, outline: true, clickable: false, class: 'border-warning text-warning-core' },
        { variant: 'missing', disabled: false, outline: true, clickable: false, class: 'border-missing text-missing-core' },
        { variant: 'success', disabled: false, outline: true, clickable: false, class: 'border-success text-success-core' },

        // Outline variants (clickable - with hover)
        { variant: 'default', disabled: false, outline: true, clickable: true, class: 'border-focus text-cta hover:bg-primary-hover' },
        { variant: 'neutral', disabled: false, outline: true, clickable: true, class: 'border-secondary text-secondary hover:bg-secondary-hover' },
        { variant: 'error', disabled: false, outline: true, clickable: true, class: 'border-error text-error-core hover:bg-primary-hover' },
        { variant: 'warning', disabled: false, outline: true, clickable: true, class: 'border-warning text-warning-core hover:bg-primary-hover' },
        { variant: 'missing', disabled: false, outline: true, clickable: true, class: 'border-missing text-missing-core hover:bg-primary-hover' },
        { variant: 'success', disabled: false, outline: true, clickable: true, class: 'border-success text-success-core hover:bg-primary-hover' },

        // Disabled variants
        { disabled: true, outline: false, class: 'bg-disabled text-disabled' },
        { disabled: true, outline: true, class: 'text-disabled' }, // TODO: border uses text color, need to change
    ],
})
